import { Component, Input, ViewChild, ElementRef, OnInit, OnDestroy } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GlobalConstants } from '../global-constants';
import { QueryService } from '../comun/services/query.service';
import { FuncionesService } from '../comun/services/funciones.service';
import { forkJoin, from } from 'rxjs';
import { concatMap, toArray, map } from 'rxjs/operators';
import { LoaderService } from '../comun/services/loader.service';
import Swal from 'sweetalert2';
import { ImagePopupService } from '../comun/services/image-popup.service';
// Para cargar el perfil del usuario conectado
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { UsuarioPerfil } from '../comun/models/misdatos.model';
import { MisdatosService } from '../comun/services/misdatos.service';
import { PerfilService } from '../comun/services/perfil.service';
import { MascotasService } from '../comun/services/mascotas.service';

@Component({
  selector: 'app-mascotas',
  templateUrl: './mascotas.component.html',
  styleUrl: './mascotas.component.css'
})
export class MascotasComponent implements OnInit, OnDestroy {
  @ViewChild('fileInputMascotaPrincipal') fileInputMascotaPrincipal!: ElementRef<HTMLInputElement>;
  @ViewChild('fileInputMascota') fileInputMascota!: ElementRef<HTMLInputElement>;
  @Input() userid: number = 0;
  private misdatosSub!: Subscription;
  misdatos: any = {};
  private perfilSub!: Subscription;
  perfil: any = {};
  private mascotasSub!: Subscription;
  mascotas: any[] = [];
  mascota: any = { ma_id: 0, ma_us_id: 0, ma_nombre: '', ma_sexo: '', ma_fecha_nac: '', ma_tipo: '', ma_raza: '', ma_descripcion: '', ma_megusta: '', ma_tamano: 0, ma_peso: 0, ma_foto_id: 0, foto: { foto_thumb: GlobalConstants.urlServer + 'img/default-dog.png' }, data: null, edit: false, vacunas: [], historial: [], identificacion: [], notas: [{},{},{}] };
  selectedFiles: any = { imagenes: [], previewUrl: [] };
  newmascota: boolean = false;
  previewUrl: string | ArrayBuffer | null = null;
  atributo: string = '';
  principal: string = '';
  error: string = '';
  tabactive: number = 0;
  busy: number = 0;
  privado_active: string = '';
  tipos_mascotas: any[] = [];
  columnas: number = 0;
  personalidadesSeleccionadas: any[] = [];
  mascotaSeleccionada: any = null;

  constructor(private query: QueryService,
              public funciones: FuncionesService,
              private http: HttpClient,
              public loader: LoaderService,
              public imagepopup: ImagePopupService,
              private misdatosService: MisdatosService,
              private perfilService: PerfilService,
              private mascotasService: MascotasService) {}

  ngOnInit() {
    this.getMisDatos();
    //this.getTiposMascotas();
  }

  getMisDatos() {
    ++this.busy;
    // 1. Escuchamos el observable misdatos$
    this.misdatosSub = this.misdatosService.misdatos$
      .pipe(
        // 2. FILTRO: Si es null, no pasa. Solo continúa si tiene datos reales.
        filter((misdatos): misdatos is UsuarioPerfil => misdatos !== null)
      )
      .subscribe((misdatos: UsuarioPerfil) => {
        // Ya tenemos datos
        this.misdatos = misdatos;
        --this.busy;
        
        this.getPerfil();
      });
    /*++this.busy;
    this.subirScroll();
    this.query.query('misdatos', 'GET', { ID: 0 }).subscribe((resultado:any) => {
      this.misdatos = resultado;
      --this.busy;
      this.getPerfil();
    });*/
  }
  ngOnDestroy() {
    // Es buena práctica desuscribirse para evitar fugas de memoria
    this.misdatosSub.unsubscribe();
    this.perfilSub.unsubscribe();
  }

  /*getTiposMascotas() {
    this.query.query('mascotas', 'TIPOS', null).subscribe((resultado:any) => {
      this.tipos_mascotas = resultado.registros;
    });
  }*/

  getTitulos(mascota: any) {
    return mascota.valores.filter((campo: any) => campo.va_tipo === 'titulo');
  }

  getPerfil() {
    ++this.busy;
    // 1. Escuchamos el observable
    this.perfilSub = this.perfilService.perfil$
      .pipe(
        // 2. FILTRO: Si es null, no pasa. Solo continúa si tiene datos reales.
        filter((perfil): perfil is UsuarioPerfil => perfil !== null)
      )
      .subscribe((perfil: UsuarioPerfil) => {
        // Ya tenemos datos
        this.perfil = perfil;
        this.getMascotas(this.mascota);
        // Distancia
        this.perfil.distancia = this.funciones.getDistanceFromLatLonInKm(this.misdatos.geolatitud, this.misdatos.geolongitud, this.perfil.geolatitud, this.perfil.geolongitud);
        --this.busy;
      });
    /*if (this.userid == this.misdatos.ID) {
      this.perfil = this.misdatos;
      this.getMascotas(this.mascota);
    } else {
      ++this.busy;
      this.query.query('misdatos', 'GET', { ID: this.userid }).subscribe((resultado:any) => {
        this.perfil = resultado;
        this.getMascotas(this.mascota);
        // Distancia
        this.perfil.distancia = this.funciones.getDistanceFromLatLonInKm(this.misdatos.geolatitud, this.misdatos.geolongitud, this.perfil.geolatitud, this.perfil.geolongitud);
        --this.busy;
      });
    }*/
  }

  subirScroll() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  getMascotas(mascota: any = null) {
    if (!this.perfil.rol_social)
      return;
    ++this.busy;
    //this.subirScroll();
    this.query.query('mascotas', 'GET', { ID: this.userid }).subscribe((resultado:any) => {
      this.mascotas = resultado.registros;
      //  Creamos un array completamente nuevo con copias de los objetos
      let mascotasClonadas = this.mascotas.map(mascota => ({ ...mascota }));
      // Clonado profundo nativo (disponible en navegadores modernos)
      mascotasClonadas = structuredClone(this.mascotas);
      this.mascotasService.setMascotas(mascotasClonadas);
      //this.mascotasService.setMascotas(this.mascotas);
      this.perfil.mascotas = this.mascotas.filter(m => m.ma_novisible === '').length;
      // Editar la última mascota añadida
      if (this.newmascota) {
        const ultimaMascota = this.mascotas.at(-1);
        if (ultimaMascota) {
            ultimaMascota.edit = true;
            this.mascota = ultimaMascota;
        }
        this.newmascota = false;
        setTimeout(() => {
          this.irAMarcador('mascota' + this.mascota.ma_id);
        }, 100);        
      }
      /*this.columnas = this.mascotas.length;
      if (this.misdatos.ID == this.perfil.ID)
        ++this.columnas;*/
      //this.privado_active = 'VACUNAS';
      //this.tabactive = this.mascotas[0].ma_id;
      /*if (mascota != null) {
        // Actualizar la mascota editada/borrada en la lista
        const index = this.mascotas.findIndex(m => m.ma_id === mascota.ma_id);
        if (index !== -1) {
          this.mascota = this.mascotas[index];
          this.mascota.data = null;
        }
      }*/
      --this.busy;
    });
  }

  nuevaMascota() {
    //this.subirScroll();
    //this.irAMarcador('newmascota');
    this.mascotaSeleccionada = null;
    this.limpiaMascota();
    this.newmascota = true;
    this.guardarMascota();
    //this.mascotas = [this.mascota, ...this.mascotas];
    //this.seleccionarMascota(this.mascota);
  }

  personalidadesAtributos() {
    this.mascota.atributos = [];
    for (const perso of this.personalidadesSeleccionadas) {
      this.mascota.atributos.push({
        at_id: 0,
        at_ma_id: this.mascota.ma_id,
        at_atributo: perso.va_nombre
      });
    }
  }

  /** Guarda el orden real de las miniaturas. Los IDs de nuevas fotos provienen de upload.php. */
  private guardarOrdenFotos(mascotaId: number, fotos: any[]): void {
    const ids = fotos.filter((f: any) => !f.borrada).map((f: any) => Number(f.ft_id));
    if (ids.some((id: number) => !Number.isInteger(id) || id <= 0) ||
        new Set(ids).size !== ids.length) {
      this.error = 'No se ha podido identificar alguna fotografía para ordenar.';
      this.loader.hide();
      return;
    }
    this.query.query('mascotas', 'ORDEN_FOTOS', { ma_id: mascotaId, fotos: ids }).subscribe({
      next: (res: any) => {
        if (res?.resultado !== 'OK') {
          this.error = res?.mensaje || 'No se pudo guardar el orden de las fotografías.';
          this.loader.hide();
          return;
        }
        this.mascota.data = null;
        this.getMascotas();
        this.loader.hide();
      },
      error: (err: any) => {
        this.error = err?.error?.mensaje || 'Error al grabar el orden en la base de datos.';
        this.loader.hide();
      }
    });
  }

  guardarMascota() {
    this.loader.show();
    this.error = '';
    this.personalidadesAtributos();
    this.query.query('mascotas', 'SAVE', this.mascota).subscribe({
      next: (resultado: any) => {
        if (resultado?.resultado !== 'OK' || !Number(resultado?.id)) {
          this.error = resultado?.mensaje || 'No se pudo guardar la mascota.';
          this.loader.hide();
          return;
        }
        const mascotaId = Number(resultado.id);
        const fotos = (this.mascota.imagenes || []) as any[];
        // Ejecutar cada subida secuencialmente para asociar su ft_id exacto.
        const operaciones: Array<() => any> = [];
        if (this.mascota.data) {
          const portada = { ft_id: 0, data: this.mascota.data, url: '', borrada: false };
          fotos.unshift(portada);
          this.mascota.imagenes = fotos;
          this.mascota.previewUrl = [
            { ft_id: 0, data: this.previewUrl, url: '', borrada: false },
            ...(this.mascota.previewUrl || [])
          ];
        }
        for (const foto of fotos) {
          if (!foto.borrada && !Number(foto.ft_id)) {
            if (!foto.data) {
              this.error = 'Una fotografía nueva no ha terminado de procesarse.';
              this.loader.hide();
              return;
            }
            operaciones.push(() => {
              const formData = new FormData();
              formData.append('data', foto.data);
              formData.append('principal', '');
              formData.append('tipo', 'MA');
              formData.append('tipo_id', String(mascotaId));
              const headers = new HttpHeaders().set('Authorization', `Bearer ${localStorage.getItem('token')}`);
              return this.http.post(GlobalConstants.urlServer + 'backend/api/upload.php', formData, { headers })
                .pipe(map((respuesta: any) => {
                  if (respuesta?.resultado !== 'OK' || !Number(respuesta.id)) {
                    throw new Error(respuesta?.mensaje || 'No se pudo subir una fotografía');
                  }
                  foto.ft_id = Number(respuesta.id);
                  return respuesta;
                }));
            });
          } else if (foto.borrada && Number(foto.ft_id)) {
            operaciones.push(() => this.query.query('misdatos', 'DELETE_FOTO', { ft_id: foto.ft_id }).pipe(
              map((respuesta: any) => {
                if (respuesta?.resultado !== 'OK') throw new Error(respuesta?.mensaje || 'No se pudo eliminar una fotografía');
                return respuesta;
              })
            ));
          }
        }
        from(operaciones).pipe(concatMap((crearPeticion: any) => crearPeticion()), toArray()).subscribe({
          next: () => this.guardarOrdenFotos(mascotaId, fotos),
          error: (error: any) => {
            this.error = error?.message || 'No se pudieron actualizar las fotografías.';
            this.loader.hide();
          }
        });
      },
      error: () => { this.error = 'No se pudo guardar la mascota.'; this.loader.hide(); }
    });
  }

  editarMascota(mascota: any) {
    //this.subirScroll();
    this.irAMarcador('newmascota');
    this.mascota = { ...mascota, atributos: [...(mascota.atributos || [])] }; // Evitar mutar la lista
    this.mascota.data = null;
    this.personalidadesSeleccionadas = [];
    this.newmascota = true;
    this.mascota.edit = true;
  }

  borrarMascota(mascota: any) {
    Swal.fire({
      title: 'Confirmación',
      text: '¿Quieres borrar esta mascota?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí',
      cancelButtonText: 'No',
      customClass: {
        confirmButton: 'custom-swal-confirm',
        /*cancelButton: 'custom-swal-cancel'*/
      },
    }).then((result) => {
      if (result.isConfirmed) {
        this.query.query('mascotas', 'DELETE', mascota).subscribe((resultado:any) => {
          this.getMascotas();
          /*this.subirScroll();
          this.getMascotas();
          this.newmascota = false;*/
        });
      } else {
      }
    });
  }

  limpiaMascota() {
    this.mascota = { ma_id: 0, 
                     ma_us_id: this.misdatos.ID, 
                     ma_nombre: '', 
                     ma_sexo: '', 
                     ma_fecha_nac: '', 
                     ma_tipo: '', 
                     ma_raza: '', 
                     ma_descripcion: '', ma_megusta: '', 
                     ma_tamano: '', 
                     ma_energia: '',
                     ma_novisible: '',
                     ma_peso: 0, 
                     ma_foto_id: 0, 
                     foto: { foto_thumb: GlobalConstants.urlServer + 'img/default-dog.png' }, 
                     imagenes: [],
                     previewUrl: [],
                     data: null, 
                     edit: false, 
                     vacunas: [], 
                     historial: [], 
                     identificacion: [], 
                     notas: [{no_texto: ''},{no_texto: ''},{no_texto: ''}] };
    this.personalidadesSeleccionadas = [];
    this.newmascota = false;
  }

  onClickImagenMascotaPrincipal() {
    // Simula el click en el input file
    this.fileInputMascotaPrincipal.nativeElement.click();
  }
  onClickImagenMascota() {
    // Simula el click en el input file
    this.fileInputMascota.nativeElement.click();
  }

  onFileSelectedPrincipal(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files?.length) {
      this.loader.show();

      const file = input.files[0];

      // Guardar la imagen original sin recortar
      const readerOriginal = new FileReader();
      readerOriginal.onload = () => {
        this.mascota.data = readerOriginal.result; // imagen original
      };
      readerOriginal.readAsDataURL(file);

      this.funciones.recortarImagenCuadrada(file, 500)
        .then((dataUrl) => {
          this.previewUrl = dataUrl;   // preview
          this.loader.hide();
        })
        .catch((err) => {
          console.error(err);
          this.loader.hide();
        });
    }
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files?.length) {
      this.loader.show();

      Array.from(input.files).forEach((file: File) => {
        // Guardar la imagen original sin recortar
        const readerOriginal = new FileReader();
        readerOriginal.onload = () => {
          this.selectedFiles.imagenes.push(readerOriginal.result); // imagen original
        };
        readerOriginal.readAsDataURL(file);

        this.funciones.recortarImagenCuadrada(file, 500)
          .then((dataUrl) => {
            this.selectedFiles.previewUrl.push(dataUrl);   // preview
            this.loader.hide();
          })
          .catch((err) => {
            console.error(err);
            this.loader.hide();
          });
      });
    }
  }

  nuevoAtributo() {

    // Máximo 6 atributos
    if (this.mascota.atributos.length >= 6) {
      // error: máximo alcanzado
      this.error = 'Solo puedes poner 6 atributos como máximo';
      return;
    }

    if (!this.atributo || !this.atributo.trim()) {
      return;
    }

    const nuevo = this.atributo.trim().toLowerCase();

    const existe = this.mascota.atributos.some(
      (a: { at_atributo: string }) =>
        a.at_atributo.trim().toLowerCase() === nuevo
    );

    if (existe) {
      // error: atributo duplicado
      this.error = 'Ese atributo ya lo tienes puesto';
      return;
    }

    this.mascota.atributos.push({
      at_id: 0,
      at_ma_id: this.mascota.ma_id,
      at_atributo: this.atributo.trim()
    });

    this.atributo = '';
    this.error = '';
  }

  quitaAtributo(atributo: string) {
    Swal.fire({
      title: 'Confirmación',
      text: '¿Quieres quitar este atributo?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí',
      cancelButtonText: 'Cancelar',
      customClass: {
        confirmButton: 'custom-swal-confirm',
        /*cancelButton: 'custom-swal-cancel'*/
      },
    }).then((result) => {
      if (result.isConfirmed) {
        this.mascota.atributos = this.mascota.atributos.filter((attr: any) => attr.at_atributo !== atributo);
        this.error = '';
      } else {
      }
    });
  }

  borrarFoto(indexABorrar: number, temporal: boolean = false) {
    Swal.fire({
      title: 'Confirmación',
      text: '¿Quieres borrar esta foto?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí',
      cancelButtonText: 'No',
      customClass: {
        confirmButton: 'custom-swal-confirm',
        /*cancelButton: 'custom-swal-cancel'*/
      },
    }).then((result) => {
      if (result.isConfirmed) {
        if (!temporal) {
          this.mascota.fotos = this.mascota.fotos.filter(
            (_: any, index: number) => index !== indexABorrar
          );
        } else {
          this.selectedFiles.imagenes = this.selectedFiles.imagenes.filter(
            (_: any, index: number) => index !== indexABorrar
          );
          this.selectedFiles.previewUrl = this.selectedFiles.previewUrl.filter(
            (_: any, index: number) => index !== indexABorrar
          );
        }
      } else {
      }
    });
  }

  dejarHuella(mascota: any) {
    this.query.query('huellas', 'HUELLA', { tipo: 'MA', tipo_id: mascota.ma_id }).subscribe((resultado:any) => {
      if (mascota.mihuella == 0) {
        mascota.mihuella = 1;
        ++mascota.huellas;
      } else {
        mascota.mihuella = 0;
        --mascota.huellas;
      }
    });
  }

  irAMarcador(id: string) {
    const yOffset = -80; // pixeles arriba
    const element = document.getElementById(id);
    if (element) {
      const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  }

  cancelarEdicion() {
    window.location.reload();
    /*this.mascota.vacunas = this.mascota.vacunas.filter((v: any) => v.va_id !== 0);
    this.mascota.historial = this.mascota.historial.filter((v: any) => v.hi_id !== 0);
    this.mascota.identificacion = this.mascota.identificacion.filter((v: any) => v.id_id !== 0);
    this.newmascota=false;*/
  }

  seleccionarMascota(mascota: any) {
    this.mascotaSeleccionada = mascota;
  }

  obtenerMascotas(): any[] {
    if (!this.mascotaSeleccionada) return this.mascotas; // Si no hay mascota seleccionada, devuelve todo (opcional)
    
    return this.mascotas.filter(mascota => mascota.ma_id === this.mascotaSeleccionada.ma_id);
  }

  maximoMascotasAlcanzado(max: number = 4): any[] {
    return this.mascotas.slice(0, max);
  }

}
